export const renderLeftRight = (leftVal, rightVal, name) => {
  const hasAny = leftVal || rightVal;

  return (
    <>
      {hasAny ? (
      <div className="d-flex align-items-center gap-01">
      <p className="heading ar_dot align-items-center d-flex gap-1">{name}:</p>
      <p className="text">
        {leftVal && (
          <>
            {leftVal}{" "}
            <span className='font-m fst-italic'>(Left)</span>
          </>
        )}

        {leftVal && rightVal && ", "}

        {rightVal && (
          <>
            {rightVal}{" "}
            <span className='font-m fst-italic'>(Right)</span>
          </>
        )}
      </p>
    </div>) : <></>}
    </>
    );
  };